<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- Header -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "Users" | transloco }}</span>
        <h2 class="bb-page-title">{{ "Users" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "Manage system users" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/Resigter" class="bb-btn bb-btn-primary">
          <i class="fa-solid fa-user-plus"></i>
          {{ "add User" | transloco }}
        </button>

        <!-- User Type Filter -->
        <div class="bb-select-wrap">
          <select
            class="bb-select"
            [value]="selectedUserType"
            (change)="filterByUserType($any($event.target).value)"
          >
            <ng-container *ngFor="let type of filteredUserTypes">
              <option [value]="type.value">
                {{ type.label | transloco }}
              </option>
            </ng-container>
          </select>
        </div>

        <!-- Warehouse Dropdown -->
        <div class="dropdown" *ngIf="allWareHouses.length > 0">
          <button
            class="bb-btn bb-btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-store"></i>
            {{ "Pospage" | transloco }}
          </button>

          <ul class="dropdown-menu dropdown-menu-end">
            <li *ngFor="let el of allWareHouses">
              <a class="dropdown-item" (click)="applyWareHouse(el.id)">
                {{ el.name }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Search Button -->
        <button class="bb-btn bb-btn-secondary" (click)="toggleSearch()" [title]="'Search' | transloco">
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>

        <!-- Export -->
        <button class="bb-btn bb-btn-secondary" (click)="exportToExcel()" [title]="'Export' | transloco">
          <i class="fa-solid fa-file-excel"></i>
        </button>
      </div>
    </header>

    <!-- Card -->
    <div class="bb-table-card bb-p-16">

      <!-- Search -->
      <div class="bb-filter-card" *ngIf="showSearch">
        <div class="search-row">
          <div class="search-box bb-search-full">
            <input
              #searchInput
              type="text"
              class="bb-input"
              [value]="searchValue"
              (input)="applyFilter($event)"
              placeholder="{{ 'Search' | transloco }}"
              [attr.aria-label]="'Search' | transloco"
            />

            <button
              type="button"
              class="bb-btn bb-btn-secondary"
              *ngIf="searchValue"
              (click)="clearSearch(searchInput)"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="bb-table-scroll">
        <table
          mat-table
          id="userstable"
          [dataSource]="dataSource"
          class="bb-table"
        >

          <!-- Username Column -->
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "username" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <div class="bb-flex bb-items-center bb-gap-12">
                <div class="bb-client-avatar">
                  {{ element.first_name?.charAt(0) | uppercase }}
                </div>

                <span class="bb-text-blue bb-font-bold">
                  {{ element.username }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Full Name Column -->
          <ng-container matColumnDef="first_name">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "Full Name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              {{ element.first_name }}
            </td>
          </ng-container>

          <!-- Invoice Name Column -->
          <ng-container matColumnDef="last_name">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "Invoice Name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              {{ element.last_name }}
            </td>
          </ng-container>

          <!-- Phone Column -->
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "phone" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <span class="bb-badge bb-badge-soft-blue">
                <i class="fa-solid fa-phone"></i>
                {{ element.phone }}
              </span>
            </td>
          </ng-container>

          <!-- Account Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              {{ "account type" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              <div [ngSwitch]="getUserType(element)">

                <span class="bb-badge bb-badge-primary" *ngSwitchCase="'10'">
                  {{ "super admin" | transloco }}
                </span>

                <span class="bb-badge bb-badge-warning" *ngSwitchCase="'6'">
                  {{ "subadmin" | transloco }}
                </span>

                <span class="bb-badge bb-badge-soft-blue" *ngSwitchCase="'7'">
                  {{ "employee" | transloco }}
                </span>

                <span class="bb-badge bb-badge-soft-cyan" *ngSwitchCase="'8'">
                  {{ "deliveryhero" | transloco }}
                </span>

                @if (warehouseTypeService.isCompany()) {
                  <span class="bb-badge bb-badge-soft-cyan" *ngSwitchCase="'2'">
                    {{ "Affiliation" | transloco }}
                  </span>

                  <span class="bb-badge bb-badge-warning" *ngSwitchCase="'3'">
                    {{ "Page A" | transloco }}
                  </span>

                  <span class="bb-badge bb-badge-success" *ngSwitchCase="'4'">
                    {{ "B" | transloco }}
                  </span>

                  <span class="bb-badge bb-badge-danger" *ngSwitchCase="'5'">
                    {{ "C" | transloco }}
                  </span>

                  <span class="bb-badge bb-badge-success" *ngSwitchCase="'9'">
                    {{ "client" | transloco }}
                  </span>
                }

                <span class="bb-badge bb-badge-danger" *ngSwitchDefault>
                  {{ "admin" | transloco }}
                </span>

              </div>
            </td>
          </ng-container>

          <!-- Instagram Column -->
          <ng-container matColumnDef="instagram_link">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              <i class="fa-brands fa-instagram"></i>
              {{ "instagram" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              @if (!element.instagram_link) {
                <span class="bb-text-muted bb-font-semibold">
                  {{ "not specific" | transloco }}
                </span>
              } @else {
                <a (click)="go(element.instagram_link)" class="bb-link-action">
                  <i class="fa-brands fa-instagram"></i>
                  {{ "instagram" | transloco }}
                </a>
              }
            </td>
          </ng-container>

          <!-- Tiktok Column -->
          <ng-container matColumnDef="tiktok_link">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              <i class="fa-brands fa-tiktok"></i>
              {{ "tiktok" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              @if (!element.tiktok_link) {
                <span class="bb-text-muted bb-font-semibold">
                  {{ "not specific" | transloco }}
                </span>
              } @else {
                <a (click)="go(element.tiktok_link)" class="bb-link-action">
                  <i class="fa-brands fa-tiktok"></i>
                  {{ "tiktok" | transloco }}
                </a>
              }
            </td>
          </ng-container>

          <!-- Facebook Column -->
          <ng-container matColumnDef="facebook_link">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
              <i class="fa-brands fa-facebook"></i>
              {{ "facebook" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" class="mat-cell-custom">
              @if (!element.facebook_link) {
                <span class="bb-text-muted bb-font-semibold">
                  {{ "not specific" | transloco }}
                </span>
              } @else {
                <a (click)="go(element.facebook_link)" class="bb-link-action">
                  <i class="fa-brands fa-facebook"></i>
                  {{ "facebook" | transloco }}
                </a>
              }
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="delete">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="mat-header-cell-custom bb-actions-th"
            ></th>

            <td
              mat-cell
              *matCellDef="let element"
              class="mat-cell-custom bb-actions-td"
            >
              <div class="dropdown bb-action-dropdown">
                <button
                  class="bb-icon-btn"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="{{ 'Actions' | transloco }}"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>

                <ul class="dropdown-menu dropdown-menu-end">

                  <li>
                    <a class="dropdown-item" (click)="edituser(element)">
                      {{ "Edit" | transloco }}
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" (click)="showpassword(element.read_password)">
                      {{ "Show Password" | transloco }}
                    </a>
                  </li>

                  <li>
                    <hr class="dropdown-divider">
                  </li>

                  <li>
                    <a class="dropdown-item text-danger" (click)="deleteuser(element.id)">
                      {{ "Delete" | transloco }}
                    </a>
                  </li>

                </ul>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>

        </table>
      </div>

      <!-- Mat Paginator -->
      <mat-paginator
        class="bb-paginator"
        *ngIf="totalUsers > 0"
        [length]="totalUsers"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"
      >
      </mat-paginator>

    </div>

    @if (noData && !contentReady) {
      <div class="bb-empty-state">
        <app-nodata></app-nodata>
      </div>
    }

  </div>
</section>